// src/components/SiteFooter.jsx — website-only footer. The same bundle powers
// the installed app and the website; a footer is what makes a browser page
// read as a "site" rather than an app screen, so it renders ONLY on the web
// (never in the Capacitor shell) and stays off full-height chat surfaces.
import { useNavigate } from 'react-router-dom';
import { isNativeApp } from '../utils/platform';

const YEAR = new Date().getFullYear();

const COLS = [
  {
    head: 'Platform',
    links: [
      ['News Feed', '/feed'], ['My Courses', '/my-courses'],
      ['Practice Quiz', '/quiz'], ['Study Groups', '/groups'],
    ],
  },
  {
    head: 'Account',
    links: [
      ['Profile', '/profile'], ['Subscription', '/subscription'],
      ['My Results', '/my-results'], ['Settings', '/account'],
    ],
  },
  {
    head: 'Support',
    links: [
      ['Notifications', '/notifications'], ['Q&A Forum', '/qa-forum'],
      ['Study Planner', '/planner'], ['CGPA Tracker', '/cgpa'],
    ],
  },
];

export default function SiteFooter() {
  const navigate = useNavigate();
  if (isNativeApp()) return null;

  return (
    <footer className="site-footer" style={{
      marginTop: 48, borderTop: '1px solid var(--nat-d)', background: 'var(--nat-s)',
      padding: '36px 24px 28px',
    }}>
      <div style={{ maxWidth: 1080, margin: '0 auto' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 36, justifyContent: 'space-between' }}>
          <div style={{ maxWidth: 300 }}>
            <div style={{ fontFamily: 'var(--display)', fontWeight: 800, fontSize: 17, color: 'var(--txt)' }}>
              Toppers Tutorial
            </div>
            <div style={{ fontSize: 13, color: 'var(--txt-l)', marginTop: 6, lineHeight: 1.6 }}>
              Awakening the Excellence — courses, practice questions, study groups
              and more for Nigerian students.
            </div>
          </div>
          {COLS.map(col => (
            <div key={col.head}>
              <div style={{ fontSize: 12, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.6px', color: 'var(--txt-m)', marginBottom: 10 }}>
                {col.head}
              </div>
              {col.links.map(([label, path]) => (
                <div key={path} style={{ marginBottom: 7 }}>
                  <a
                    href={path}
                    onClick={e => { e.preventDefault(); navigate(path); }}
                    style={{ fontSize: 13, color: 'var(--txt-l)', textDecoration: 'none' }}
                    onMouseEnter={e => { e.currentTarget.style.color = 'var(--org)'; }}
                    onMouseLeave={e => { e.currentTarget.style.color = 'var(--txt-l)'; }}
                  >{label}</a>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div style={{
          marginTop: 28, paddingTop: 16, borderTop: '1px solid var(--nat-d)',
          display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', justifyContent: 'space-between',
          fontSize: 12, color: 'var(--txt-xl)',
        }}>
          <span>© {YEAR} Toppers Tutorial. All rights reserved.</span>
          <span>www.topperstutorial.com.ng</span>
        </div>
      </div>
    </footer>
  );
}
